import { defineStore } from "pinia";

export const useFeaturesStore = defineStore(
  "Features",
  () => {
    const seenFeatures = ref<string[]>([]);

    const addSeenFeature = (featureId: string) => {
      seenFeatures.value.push(featureId);
    };

    return {
      seenFeatures,
      addSeenFeature,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  }
);
